// Her kumaş tipine özel kodlar
const fabricTypeCodes: { [key: string]: string } = {
  // Örme kumaşlar - 01-50 arası kodlar
  'Süprem': '01',
  'suprem': '01',
  'Ribana': '02',
  'ribana': '02',
  'İnterlok': '03',
  'interlok': '03',
  'Interlock': '03',
  'interlock': '03',
  'Pike': '04',
  'pike': '04',
  'Selanik': '05',
  'selanik': '05',
  'Kaşkorse': '06',
  'kaşkorse': '06',
  'Üç İplik': '07',
  'üç iplik': '07',
  'İki İplik': '08',
  'iki iplik': '08',
  'Şardon': '09',
  'şardon': '09',
  'Penye': '10',
  'penye': '10',
  'Lakost': '11',
  'lakost': '11',
  'Elastan': '12',
  'elastan': '12',
  'Merserize': '13',
  'merserize': '13',
  'Modal': '14',
  'modal': '14',
  'Viskon': '15',
  'viskon': '15',
  'Dalgalı': '16',
  'dalgalı': '16',
  'Fitilli': '17',
  'fitilli': '17',
  'Futter': '18',
  'futter': '18',
  'Jakar': '19',
  'jakar': '19',
  'Flam': '20',
  'flam': '20',

  // Dokuma kumaşlar - 51-99 arası kodlar
  'Gabardin': '51',
  'gabardin': '51',
  'Kadife': '52',
  'kadife': '52',
  'Poplin': '53',
  'poplin': '53',
  'Saten': '54',
  'saten': '54',
  'Şifon': '55',
  'şifon': '55',
  'Keten': '56',
  'keten': '56',
  'Oxford': '57',
  'oxford': '57',
  'Denim': '58',
  'denim': '58',
  'Tafta': '59',
  'tafta': '59',
  'Krep': '60',
  'krep': '60',
  'Alpaka': '61',
  'alpaka': '61',
  'Organze': '62',
  'organze': '62',
  'Tergal': '63',
  'tergal': '63',
  'Tüvit': '64',
  'tüvit': '64',
  'Kaşmir': '65',
  'kaşmir': '65',
  'Kord': '66',
  'kord': '66',
  'Şantuk': '67',
  'şantuk': '67',
  'Panama': '68',
  'panama': '68',
  'Kaşe': '69',
  'kaşe': '69',
  'Astar': '70',
  'astar': '70'
};

// Boyama tipi kodları
const dyeingTypeCodes = {
  'yarn_dyed': '01',    // İplik boyalı
  'piece_dyed': '02',   // Parça boyalı
  'printed': '03',      // Baskılı
  'digital': '04',      // Dijital baskı
  'garment_dyed': '05', // Mamul boyama
  'raw_white': '06',    // Ham beyaz
  'reactive': '07',     // Reaktif boyama
  'disperse': '08',     // Dispers boyama
  'pigment': '09',      // Pigment boyama
  'acid': '10'          // Asit boyama
};

export const generateFabricCode = (
  fabricClass: 'woven' | 'knitted',
  fabricType: string,
  dyeingType: string
): string => {
  // Sınıf kodu: Örme için 01, Dokuma için 02
  const classCode = fabricClass === 'knitted' ? '01' : '02';
  
  // Tip kodunu bulmadan önce string'i normalize et
  const cleanType = fabricType
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, ''); // Türkçe karakterleri temizle

  console.log('[FabricCodeGenerator] Aranan tip:', cleanType);
  
  // Normalize edilmiş tip kodları
  const normalizedTypeCodes = Object.entries(fabricTypeCodes).reduce((acc, [key, value]) => {
    const normalizedKey = key
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    acc[normalizedKey] = value;
    return acc;
  }, {} as { [key: string]: string });

  // Tip kodunu bul
  let typeCode = normalizedTypeCodes[cleanType];
  
  console.log('[FabricCodeGenerator] Bulunan tip kodu:', typeCode);
  console.log('[FabricCodeGenerator] Mevcut tip kodları:', normalizedTypeCodes);

  // Tip kodu bulunamadıysa varsayılan değer ata
  if (!typeCode) {
    typeCode = fabricClass === 'knitted' ? '50' : '98';
    console.log('[FabricCodeGenerator] Tip kodu bulunamadı, varsayılan değer atandı:', typeCode);
  }

  // Boyama kodu bul
  const dyeingCode = dyeingTypeCodes[dyeingType] || '99';
  
  // Rastgele iki haneli seri numarası (00-99)
  const serialNumber = Math.floor(Math.random() * 100)
    .toString()
    .padStart(2, '0');
  
  // K + sınıf(2) + tip(2) + boyama(2) + seri(2)
  const code = `K${classCode}${typeCode}${dyeingCode}${serialNumber}`;
  console.log('[FabricCodeGenerator] Oluşturulan kod:', code);
  return code;
};
